import bbox from "@turf/bbox";
import { yyyy } from "../../store.svelte";
const url: string = yyyy.uri.api;

export let bookmarkSearch = async (term: string) => {
	let _hdrs = {
		"Content-Type": "application/json",
		Authorization: "Bearer " + yyyy.sesh.logtoken.token,
		Accept: "application/geo+json",
	};
	let fetchopts = { method: "get", headers: _hdrs };
	let fullurl: string;

	if (term) {
		console.log("search term exists");
		fullurl = `${url}/bookmarks?wireident=eq.${yyyy.sesh.activeLivewire.wireident}&title=imatch.${term}`;
	} else {
		console.log("no search term provided");
		fullurl = `${url}/bookmarks?wireident=eq.${yyyy.sesh.activeLivewire.wireident}`;
	}
	const resp = await fetch(fullurl, fetchopts);
	if (resp.ok) {
		let data = await resp.json();
		yyyy.map.zote.answrs.mrks = data.features;
		console.log("bookmark:", data);
		return data.features
	}
	if (!resp.ok) {
		console.log("Bokmark search failed");
	}
	yyyy.map.zote.searchActive = true;
	yyyy.map.zote.menuActive = false;
};

export let mapSearch = async (term: string) => {
	console.log(yyyy.sesh.activeLivewire.wireident)
	let _body = JSON.stringify({
		what: term,
		lw: yyyy.sesh.activeLivewire.wireident,
	});

	let _hdrs = {
		"Content-Type": "application/json",
		Authorization: "Bearer " + yyyy.sesh.logtoken.token,
	};
	let fetchopts = { method: "post", body: _body, headers: _hdrs };
	const response = await fetch(`${url}/rpc/searchfor`, fetchopts);

	if (response.ok) {
		let resp = await response.json();
		console.log(resp);
		if (resp === null) {
			yyyy.map.idnt = [];
			return []
		} else {
			//yyyy.map.idnt = resp.features;
			return resp
		}
	} else {
		alert("Bad");
		console.log(response.text());
	}
};

export let placeSearch = async (term: string) => {
	let gc = new URL(`https://api.maptiler.com/geocoding/${term}.json`);
	let qp = new URLSearchParams({
		key: "1FjXzViIh9liQSgm4uks",
		proximity: [yyyy.map.location.coords.lng, yyyy.map.location.coords.lat],
		limit: 10,
		bbox: bbox(yyyy.sesh.activeLivewire.extent),
	});
	gc.search = qp.toString();
	console.log("gc: ", gc.toString());
	let fetchopts = { method: "get" };
	const response = await fetch(gc.toString(), fetchopts);

	if (response.ok) {
		let resp = await response.json();
		console.log("places: ", resp);
		if (resp.features === null) {
			yyyy.map.zote.answrs.plcs = [];
			return []
		} else {
			let data = resp.features.filter(
				(item: any) => item.relevance > 0.7,
			);

			yyyy.map.zote.answrs.plcs = data
			return data
		}
	} else {
		alert("Bad");
		console.log(response.text());
	}
};

